export default "__VITE_ASSET__0707df5e__"